import React from 'react';
import './checkbox.scss';

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: React.ReactNode;
  className?: string;
};

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({ label, className = '', id, ...inputProps }, ref) => {
  // generate id if not provided
  const uid = React.useMemo(() => id || `cb-${Math.random().toString(36).slice(2, 9)}`, [id]);

  return (
    <div className={`checkbox-wrapper-19 ${className}`}>
      <input id={uid} ref={ref} type="checkbox" {...(inputProps as React.InputHTMLAttributes<HTMLInputElement>)} />
      <label htmlFor={uid} className={`check-box`}></label>
      {label && <span className="ml-3 text-sm text-gray-700">{label}</span>}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
